import React, { useState, useEffect, Link } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import AdSense from 'react-adsense';
import { Cookies } from '../../index.js';
import { Helmet } from "react-helmet";
import { animateScroll as scroll } from 'react-scroll';
import { isMobile } from 'react-device-detect';
import Select from 'react-select';
import { alert_error, alert_success } from '../../AppContext';
import { isLocalHost } from '../../shared/host_utils.js';
function Rutgonlink() {
  const { slug_2 } = useParams();
  const navigate = useNavigate();
  const recaptchaRef = React.createRef();
  const [inputmota, setinputmotat] = useState('');
  const [taikhoan, settaikhoan] = useState('');
  const [chedo, setchedo] = useState('');
  const [nutorder, setnutorder] = useState('Xác nhận captcha');
  const [thanhcong2, setthanhcong2] = useState('');
  const [nutxuly, setnutxuly] = useState(1);
  const [inputamount, setinputamount] = useState('');
  const [service, setservice] = useState('');
  const [captcha, setcaptcha] = useState('');
  const [content, setcontent] = useState('');
  const [withdrawReason, setWithdrawReason] = useState('');
  const [hanmuc, sethanmuc] = useState('');
  const [balance, setbalance] = useState('');
  const [money_crypto, setmoney_crypto] = useState('');
  const [chietkhau, setchietkhau] = useState('');

  const [options, setoptions] = useState([
    {
      id: '', stt: '', name: 'Chọn 1 kiểu rút tiền',
      money: '', status: 'show', content: '', servicecode: ''
    }
  ]);

  const handleOptionChange = (selectedOption) => {
    setIsOpen(false);
    const selectedOptionpro = selectedOption.value;
    setservice(selectedOptionpro);
    const selectedOptionok = options.find((option) => option.id == selectedOptionpro);

    setcontent(selectedOptionok);
    // Thêm các hành động khác tại đây dựa trên lựa chọn của người dùng
  }
  function gopdulieu(response) {
    const arr1 = [
      {
        id: '', stt: '', name: 'Chọn 1 cấp độ dịch vụ',
        money: '', status: 'show', content: '', servicecode: ''
      }
    ];

    const arr2 = response.data;

    setoptions(arr1.concat(arr2));
  };
  const handleRecaptchaChange = (value) => {
    console.log(value);
    const maxLength = 200;

    if (value.length > maxLength) {
      setcaptcha(value);
      setnutxuly(0);
      setnutorder('Xác nhận');
    }
    else {
      setnutorder('Đã xảy ra lỗi tải lại trang nhé');
    }
  };
  function laydulieu(value) {
    if (value == 'pay_bank') {
      const category = 'bank';
      axios
        .post('https://hust.media/getservice/service.php', {
          category: category
        })
        .then(response => gopdulieu(response))
        .catch(error => console.log(error))
    }
    else if (value == 'pay_momo') {
      const category = 'money';
      axios
        .post('https://hust.media/getservice/service.php', {
          category: category
        })
        .then(response => gopdulieu(response))
        .catch(error => console.log(error))
    }
  };
  function thongtintk(value) {
    setthanhcong2(true);
    const apikey = Cookies.get('apikey');
    const domain = window.location.hostname;
    axios
      .get('https://hust.media/jop/pay/checktk.php?apikey=' + apikey + '&chedo=' + value + '&domain=' + domain)
      .then(response => testFunction(response))
      .catch(error => alert_error(error))
  };
  function testFunction(response) {
    let info = response?.data;
    if (typeof info === 'string') {
      try {
        info = JSON.parse(info);
      } catch (e) {
        try {
          const jsonText = info.slice(info.indexOf('{'), info.lastIndexOf('}') + 1);
          info = JSON.parse(jsonText);
        } catch (_e) {
          info = {};
        }
      }
    }
    if (info && typeof info === 'object' && info.data && typeof info.data === 'object') {
      info = info.data;
    }
    if (!info || typeof info !== 'object') {
      info = {};
    }
    const status = String(info.status ?? info.Status ?? '').trim();
    const hasRedirect = info.redirect != null && info.redirect != '';
    const isSuccess = status === '1' || status.toLowerCase() === 'success' || hasRedirect;

    setnutxuly(0);
    if (status === '0') {
      setnutorder('đặt tiếp luôn nào')
      alert_error(info.message);
      window.grecaptcha.reset();
    }
    else if (isSuccess) {
      setnutorder('Thành công')
      alert_success(info.message || 'Thành công');
    }
    else if (status === '5') {
      sethanmuc(info.hanmuc);
      setmoney_crypto(info.money_crypto);
      setchietkhau(info.chietkhau);
      settaikhoan(info.taikhoan);
      setbalance(info.balance);
      window.grecaptcha.reset();
    }
    else {
      setnutorder('đã xảy ra lỗi vui lòng liên hệ admin')
    }
    if (hasRedirect) {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        window.location.href = info.redirect;
      }, 1700);
    }
  };
  const scrollToBottom = () => {
    scroll.scrollToBottom({ duration: 200 }); // Cuộn xuống hết trang trong 800ms
  };
  function handleSubmit(event) {
    setnutxuly(0);
    const apikey = Cookies.get('apikey');
    event.preventDefault();

    setnutxuly(1);
    setnutorder('Please wait a moment 😊');
    // if (!inputamount || !service) {
    //   alert_error('Please điền đầy đủ thông tin')
    //   setnutxuly(0);
    //   setnutorder('điền đủ thông tin');
    //   return
    // }
    axios
      .post('https://hust.media/api/wallet/e_commerce/seller_pay_orders.php', {
        amount: inputamount,
        apikey: apikey,
        mota: inputmota,
        comments: withdrawReason,
        service: service,
        captcha: captcha,
        chedo: chedo
      })
      .then(response => (testFunction(response)))
      .catch(error => (alert_error(error),
        setnutxuly(0),
        window.grecaptcha.reset()))

  }

  function saochep(value) {
    alert_success('Đã sao chép');
    window.saochepnative(value);

  };
  const [isOpen, setIsOpen] = useState(true);

  const handleFocus = () => {
    setIsOpen(true);
    console.log(123);
  };
  const handleBlur = () => {
    setIsOpen(false);
  };
  const handleMenuOpen = () => {
    setIsOpen(true);
  };
  useEffect(() => {
    setchedo(slug_2);
    if (slug_2 == 'pay_momo') {
      setservice('85781');
    }
    else if (slug_2 == 'pay_bank') {
      setservice('68971');
    } else if (slug_2 == 'pay_crypto') {
      setservice('546840');
    } else if (slug_2 == 'pay_binance') {
      setservice('553660');
    }
  }, []);
  useEffect(() => {
    const apikey = Cookies.get('apikey');
    if (isMobile || isLocalHost(window.location.hostname) || window.location.hostname == 'tecom.pro') {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.includes("hustmedianative") || userAgent.includes("hustmedia-android")
        || isLocalHost(window.location.hostname) || window.location.hostname == 'tecom.pro') {
        laydulieu();
        thongtintk(slug_2);
      } else {
        alert_error('Vui lòng tải app để sử dụng tính năng này');
        setTimeout(() => {
          navigate('/reactapp/thankiu');
        }, 700);
      }
    }
    else {
      alert_error('Vui lòng tải app để sử dụng tính năng này');
      setTimeout(() => {
        navigate('/reactapp/thankiu');
      }, 700);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title> Rút tiền ngân hàng</title>
      </Helmet>
      <div data-type="_mgwidget" data-widget-id="1662830">
      </div>
      {
        thanhcong2 &&
        (<>
          <Helmet>
            {/* <script data-cfasync="false" type="text/javascript" src="//usjbwvtqwv.com/bultykh/ipp24/7/bazinga/1979702" async></script> */}
            {/* <script async="async" data-cfasync="false" src="//ophoacit.com/1?z=5904788"></script> */}
            <script data-cfasync="false" type="text/javascript" src="//hhbypdoecp.com/lv/esnk/1978451/code.js" async id="__clb-1978451"></script>
            <script>
              {`(function(w,q){w[q] = w[q] || [];w[q].push(["_mgc.load"])})(window,"_mgq");`}
            </script>
          </Helmet>
        </>)
      }
      <div>

        <div
          className="
          antialiased
          bg-gradient-to-r
          from-pink-300
          via-purple-300
          to-indigo-400
        "
        >

          <div className="mt-0 mx-2">

            <AdSense.Google
              client="ca-pub-4574266110812955"
              slot="5828045161"
              style={{ display: 'block' }}
              format="auto"
              responsive="true"
            />
            <form className="add-form">

              <div className="form-control">
                <div className="row align-items-center">
                  {/* <div className="col mb-0">
                    <div className="col text-left">
                      <label>Nhập số tiền</label>
                    </div>
                  </div> */}
                  {
                    chedo == 'pay_crypto' ?
                      (<>
                      </>) :
                      (<>
                        {chedo == 'pay_momo' ?
                          (<>
                            <div className="col text-right">
                              <a href="/reactapp/themsdt?app=showadview" className="btn btn-sm btn-primary">Thay tk rút tiền</a>
                            </div>
                          </>) :
                          (<>
                            <div className="col text-right">
                              <a href="/shop/e-commerce/seller/edit_bank?showadview=true" className="btn btn-sm btn-primary">Thay tk rút tiền</a>
                            </div>
                          </>)}
                      </>)
                  }
                </div>

                {inputamount && content.minorder && (<><div className="flex justify-center items-center text-xs" > tối thiểu {content.minorder} tối đa {content.maxorder} </div></>)}
                <div v-if="comota" >
                  <div className="row align-items-center">
                    <div className="col mb-0">
                      <div className="col text-left">
                        {
                          chedo == 'pay_crypto' ?
                            (<>
                              <label>Nhập email faucetpay để Hust chuyển USDC về ví của bạn. <a href="https://faucetpay.io/?r=5992837" >Đăng ký ví faucetpay ở đây</a></label>
                            </>) : chedo == 'pay_binance' ?
                              (<>
                                <label>Nhập địa chỉ ví USDT bianance BEP20 để Hust chuyển USDT về ví của bạn. <a href="https://www.binance.com/activity/referral-entry/CPA?ref=CPA_00CYT8IRNX" >Đăng ký ví bianance ở đây</a></label>
                                  <div>Ví dụ: 0x41dfcb0b4dc621088eb87b7ac715d75e93d13ff0 </div>
                              </>) : chedo != 'pay_bank' &&
                              (<>
                                <label>Nội dung rút tiền</label>
                              </>)
                        }
                      </div>
                    </div>
                    {inputamount && content.money && chietkhau && (
                      <div className="col text-right">
                        <div className="text-base">
                          Tổng: {(inputamount * content.money * (100 - chietkhau) / 100).toFixed(0)} Coins
                        </div>
                      </div>
                    )}
                  </div>


                  {chedo != 'pay_bank' && (
                    <div className="input-group flex-nowrap">
                      {
                        chedo == 'pay_crypto' ?
                          (<>
                            <span className="input-group-text" id="addon-wrapping">Email</span>
                            <input
                              onChange={e => setinputmotat(e.target.value)}
                              value={inputmota} type="text" className="form-control" placeholder="Nhập email faucetpay" aria-label="inputmota" name="inputmota" aria-describedby="addon-wrapping">
                            </input>
                          </>) : chedo == 'pay_binance' ?
                            (<>
                              <span className="input-group-text" id="addon-wrapping">BEP20</span>
                              <input
                                onChange={e => setinputmotat(e.target.value)}
                                value={inputmota} type="text" className="form-control" placeholder="Nhập địa chỉ ví USDT" aria-label="inputmota" name="inputmota" aria-describedby="addon-wrapping">
                              </input>
                            </>) :
                            (<>
                              <span className="input-group-text" id="addon-wrapping">Mô tả</span>
                              <input
                                onChange={e => setinputmotat(e.target.value)}
                                value={inputmota} type="text" className="form-control" placeholder="Không bắt buộc" aria-label="inputmota" name="inputmota" aria-describedby="addon-wrapping">
                              </input>
                            </>)
                      }
                    </div>
                  )}
                  {chedo != 'pay_crypto' && chedo != 'pay_binance' && (
                    <div className="mt-2">
                      <label>Nguồn coins đến từ đâu (bắt buộc)</label>
                      <div className="input-group flex-nowrap">
                        <span className="input-group-text" id="addon-wrapping">Lý do</span>
                        <input
                          onChange={e => setWithdrawReason(e.target.value)}
                          value={withdrawReason}
                          type="text"
                          className="form-control"
                          placeholder="Nhập nguồn coins"
                          aria-label="withdrawReason"
                          name="withdrawReason"
                          aria-describedby="addon-wrapping"
                          required
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="max-h-16">
                  <div className="cards">
                    <AdSense.Google
                      client="ca-pub-4574266110812955"
                      slot="1627514116"
                      style={{ display: 'block', height: 50 }}
                      format=""
                    /> </div>
                </div>
                <div className="row align-items-center">

                  {chietkhau && (<div className="col text-left">
                    <div className="text-sm">
                      Chiết khấu: {chietkhau}%
                    </div>
                  </div>
                  )}
                  {inputamount && content.money && (
                    <div className="col text-right text-base">
                      Số tiền nhận: {inputamount} VNĐ
                    </div>
                  )}

                </div>

              </div>

              <ReCAPTCHA
                className="flex justify-center items-center "
                ref={recaptchaRef}
                sitekey="6LfHUSYeAAAAAI8X84A9EXqbovZpFJyYmhiveXYD"
                onChange={handleRecaptchaChange}
              />
              <div className='mt-1 mb-0 text-center text-sm'>    {taikhoan}</div>


              <button disabled={nutxuly == 1} onClick={handleSubmit}
                className='mt-2 mb-1 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2  w-full dark:bg-slate-800 dark:text-white'>
                <div className='flex items-center justify-between flex-1'>
                  {nutxuly == 1 &&
                    <div className="spinner-border" role="status">

                    </div>}


                  <span className='text-lg font-medium text-white'>
                    {nutorder} </span>
                  <div className="text-xl">
                    {'\u27A4'}
                  </div>
                </div>
              </button>
            </form>
          </div>
        </div >
        <br></br>
      </div >    </>
  )
}

export default Rutgonlink;
